import MessageGroupRequest from "@/model/requests/MessageGroupRequest";
import MessageGroupServices from "@/services/MessageGroupServices";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";
import MessageRequestRequest from "@/model/requests/MessageRequestRequest";
import customerMessages from "@/views/timeslot/customer/CustomerMessages";
const messageGroupService = new MessageGroupServices();

export const namespaced = true;

export const state = {
  messagesInGroup: [],
  customerMessages: [],
  singleMessageGroup: [],
  allCustomerMessages: []
};

export const getters = {};

export const mutations = {
  setMessagesInGroup: (state, payload) => {
    state.messagesInGroup = payload;
  },
  setCustomerMessages: (state, payload) => {
    state.customerMessages = payload;
  },
  setSingleMessageGroup: (state, payload) => {
    state.singleMessageGroup = payload;
  },
  setAllCustomerMessages: (state, payload) => {
    state.allCustomerMessages = payload;
  }
};

export const actions = {
  readByMessageGroupId({ commit }, payload = MessageGroupRequest.readBy) {
    let successAction = responseData => {
      commit("setMessagesInGroup", responseData.data);
    };
    return messageGroupService.readMessageByMessageGroupId(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readByMessageGroupByCustomerId(
    { commit },
    payload = MessageGroupRequest.readByCustomerId
  ) {
    let successAction = responseData => {
      commit("setCustomerMessages", responseData.data);
      commit("setSingleMessageGroup", responseData.data[0]);
      commit("setAllCustomerMessages", responseData.data);
    };
    return messageGroupService.readMessageByCustomerId(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  createMessageGroup({ commit }, payload = MessageGroupRequest.create) {
    let successAction = () => {};
    return messageGroupService.createMessage(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  createMessage({ commit }, payload = MessageRequestRequest.createMessage) {
    let successAction = () => {};
    return messageGroupService.createMessage(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  }
};
